import { goldenURL, GoldenURLType } from '@golden/url'

export const getServerUrl = (system: GoldenURLType): string => {
  return goldenURL().get(system)
}
